import styles from "../GroupsTab/GroupsTab.module.scss";
import classnames from "classnames";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import React from "react";

export const MenuDownloadButton = ({
  toggleDownloadMode,
  isDownloadMode,
  disabled,
}: {
  disabled: boolean;
  isDownloadMode: boolean;
  toggleDownloadMode: VoidFunction;
}) => {
  return (
    <div className={styles.actionsMenu}>
      <div
        onClick={() => toggleDownloadMode()}
        className={classnames(styles.headerButton, {
          [styles.selected]: isDownloadMode,
          [styles.disabled]: disabled,
        })}
      >
        <SvgV2 width={15} height={15} iconName="download" data-testid={"download-menu-button"} />
      </div>
    </div>
  );
};
